<nav class="nav-list">
  <a
    *ngFor="let nav of navlistItems; trackBy: trackByLink"
    mat-button
    class="nav-list-item"
    [routerLink]="nav.link"
    routerLinkActive="active"
    [hidden]="nav?.hidden"
    [matTooltip]="isCollapsed ? nav.linkTitle : ''"
    matTooltipPosition="right"
    (click)="onClickNavItem()"
  >
    <mat-icon class="nav-list-icon">{{ nav.icon }}</mat-icon>

    <span class="nav-list-text">{{ nav.linkTitle }}</span>

    <span class="nav-list-border"></span>
  </a>
</nav>
